export { default } from './Card';
export type { Props, Props as CardProps } from './Card';
